const hex2rgb = ( hex ) => {
	if ( hex.slice(0, 1) == "#" ) hex = hex.slice(1) ;
	if ( hex.length == 3 ) hex = hex.slice(0,1) + hex.slice(0,1) + hex.slice(1,2) + hex.slice(1,2) + hex.slice(2,3) + hex.slice(2,3) ;

	return [ hex.slice( 0, 2 ), hex.slice( 2, 4 ), hex.slice( 4, 6 ) ].map( function ( str ) {
		return parseInt( str, 16 ) ;
	} ) ;
}

const rgb2darker = (rgb , diff) => {
  const r = rgb[0] - diff < 0 ? 0 : rgb[0] - diff ,
        g = rgb[1] - diff < 0 ? 0 : rgb[1] - diff ,
        b = rgb[2] - diff < 0 ? 0 : rgb[2] - diff  
  
  return [ r, g , b];
}

window.addEventListener('load', () => {


  var charaThumnail = new Swiper('.p-thumnail__container', {
    containerModifierClass: `p-thumnail__container`,
    wrapperClass: `p-thumnail__wrapper`,
    slideClass: `p-thumnail__item`,
    grabCursor: true,
    freeMode: true,
    slidesPerView: 'auto',
    loop: true,
    loopedSlides: 16,
    loopFillGroupWithBlank: true,
    observer: true,
    observeParents: true,
    spaceBetween: -20,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });


  var charaItem = new Swiper('.p-chara__container', {
    containerModifierClass: `p-chara__container`,
    wrapperClass: `p-chara__wrapper`,
    slideClass: `p-chara__item`,
    slideActiveClass: `p-chara__item--active`,
    noSwiping: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    loop: true,
    thumbs: {
      swiper: charaThumnail,
      slideThumbActiveClass: `p-thumnail__item--active`,
    },
    navigation: {
      nextEl: '.js-chara--next',
      prevEl: '.js-chara--prev',
    },
    on : {
      resize: () => {
        charaItem.update();
      }
    }
  });



  let _thumanil = document.querySelectorAll(`.js-thumnail`);
  let thumnailLen = _thumanil.length;


  let timeLine = new TimelineMax();


  const timeLineSet = () => {


    timeLine = new TimelineMax();
    timeLine.set(`.js-charaAnime`, {
        opacity: 0
      })
      .set(`.js-charaAnime--01`, {
        x: 150
      }).set(`.js-chara__band`, {
        width: 0
      });


    TweenMax.to(`.js-charaAnime--00`, 0, {
      className: `-=is-show`
    });

  }

  const timeLineStart = () => {


    //looopのときの挙動対策
    let _activeClass = document.querySelectorAll(`.p-chara__item--active`);
    let indexNum = _activeClass[0].getAttribute(`data-chara-num`);
    let temp = document.querySelectorAll(`[data-chara-num="${indexNum}"]`);

    if (temp.length > 1) {

      _activeClass = `.p-chara__item--${indexNum}`;

    } else {
      _activeClass = `.p-chara__item--active`;
    }



    timeLine = new TimelineMax();
    timeLine.to(`${_activeClass} .js-charaAnime--01`, 0.5, {
      opacity: 1,
      x: 0,
    }).to(`${_activeClass} .js-charaAnime--00`, 0.2, {
      className: `+=is-show`,
      delay: -0.3
    }).to(`${_activeClass} .js-charaAnime--00-1`, 0.2, {
      opacity: 0.5,
    }).to(`${_activeClass} .js-charaAnime--02`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--03`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--03-1`, 0.2, {
      width: `100%`,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--03-2`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--04`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--05`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--06`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--06-1`, 0.2, {
      width: `100%`,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--06-2`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--07`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--08`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--09`, 0.2, {
      opacity: 1,
      delay: -0.1
    }).to(`${_activeClass} .js-charaAnime--10`, 0.2, {
      opacity: 0.75,
      delay: -0.1
    }).to(`${_activeClass}`, 0.2, {
      className: `+=animation-end`,
    });
  }

  timeLineSet();
  timeLineStart();


  charaItem.on(`slideChangeTransitionStart`, () => {

  })


  charaItem.on(`slideChangeTransitionEnd`, () => {

    timeLineSet();

    timeLineStart();

  })



  let _characters = document.querySelectorAll(`.js-chara`);

  let charactersLen = _characters.length;


  for (let i = 0; i < charactersLen; i++) {

    let color = _characters[i].getAttribute(`data-color`);
    let txtcolor = _characters[i].getAttribute(`data-txtcolor`);

    let slash = _characters[i].querySelector(`.js-chara__slash`);

    let band = _characters[i].querySelector(`.js-chara__band`);
    let ai = _characters[i].querySelectorAll(`.js-ainame`);

    slash.style.background = color;
    band.style.background = color;

    for (let k = 0; k < ai.length; k++) {
      
      let colorArr = rgb2darker(hex2rgb(color) , 70);
      let c = `rgba( ${colorArr[0]} , ${colorArr[1]} , ${colorArr[2]} , 1 )`;
      ai[k].style.color = c;
    }



    //animation
  }

});
